import { useQuery } from 'react-query';
import { useCurrentUser } from '@qualio/ui-components';
import templateApi from '../services/templateApi';

export const BaseQueryKey = 'template';

export const useTemplateVersions = (templateUuid: string | undefined) => {
  const { companyId } = useCurrentUser();

  return useQuery(
    [BaseQueryKey, 'versions', templateUuid, companyId],
    async () => templateApi.getTemplateVersions(companyId, templateUuid as string),
    {
      enabled: !!templateUuid,
    },
  );
};
